module.exports = __webpack_public_path__ + "37fa169d92439d8efb66cb769ece45ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/bgr.jpg
// module id = 661
// module chunks = 0